import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-58485362"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "search-container" }
const _hoisted_2 = { class: "p-input-icon-left" }
const _hoisted_3 = { class: "card-body pt-0" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Actions", -1))

import AdminPageLayout from "@/layouts/default/admin/AdminPageLayout.vue";
import { fetchProductVariants, archiveVariantProduct } from "@/_services/product/variant/productVariant";
import { onMounted, ref } from "vue";
import { useRoute } from "vue-router";
import { ProductVariant } from "@/models/product/variant/ProductVariant";
import { ProductComponentObject } from "@/models/utility/ProductComponentObject";
import Button from "primevue/button";
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import swal from "@/_helpers/swal";
import { formatStatus } from "@/_helpers/stringManipulations";
import router from "@/router";
import ApiService from "@/_services/api.service";

const defaultRowsPerPage = 10;

export default /*#__PURE__*/_defineComponent({
  __name: 'ListProductVariants',
  setup(__props) {

const productVariants = Array<ProductVariant>();
const rows = ref<number>(10);
const rowsPerPageOptions = [defaultRowsPerPage, 25, 100];
const isLoading = ref<boolean>(true);
const tableData = ref<Array<ProductVariant>>(productVariants);
const route = useRoute();
let masterProductData =ref();

onMounted(async () => {
  await fetchMasterProduct();
  await populateDatatable();
});

async function populateDatatable() {  
  const [loadingDt, tableDataDt] = await fetchProductVariants({
    masterProductUuid: route.params.uuid,
    status: 1,
    isTechnical: 0
  });
  
  isLoading.value = loadingDt.value;
  tableData.value = tableDataDt.value;
}

async function fetchMasterProduct() {
  try {
    const response = await ApiService.get(`master-product/${route.params.uuid}`);
    masterProductData.value= response.data.data
  } catch (error) {
    console.error('Error fetching master product:', error);
  }
}

const onDelete = (variantUuid: string) => {
  swal
    .confirm("Êtes vous sûr de vouloir archiver ce produit ?")
    .then((result) => {
      if (result.isConfirmed) {
        archiveVariantProduct(variantUuid).then(() => {
          swal.success("Archivé !", "Le produit a bien été archivé.");          
          populateDatatable();
        }).catch((error) => {
          if (error.response.status === 422) {
            swal.error('Vous ne pouvez pas archiver ce variant. Veuillez créer un autre variant ou archiver le produit parent.');
          } else {
            swal.error();
          }
        })
      }
    });
};

function stringifyProductComponentObject(
  attributes
): string {
  let result = "";

  attributes.forEach(attribute => {
    result += `${attribute.attributeName} (${attribute.attributeValues.value}), `;
  });

  // Remove the trailing comma and space, and return the formatted string
  return result.replace(/,\s*$/, "");
}

const goBack = () => {
  router.push({ name: 'ListProducts' });
};

return (_ctx: any,_cache: any) => {
  const _component_FormKit = _resolveComponent("FormKit")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock(AdminPageLayout, null, {
    titleName: _withCtx(() => [
      _createTextVNode(" Liste des variants du produit \"" + _toDisplayString(_unref(masterProductData)?.properties?.adminProductName[0]?.value) + "\" ", 1)
    ]),
    content: _withCtx(() => [
      _createVNode(_unref(DataTable), {
        value: tableData.value,
        rows: rows.value,
        loading: isLoading.value,
        rowsPerPageOptions: rowsPerPageOptions,
        globalFilterFields: ['properties.adminProductName.value']
      }, {
        header: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("span", _hoisted_2, [
              _createVNode(_component_FormKit, {
                type: "submit",
                label: "Retour",
                onClick: goBack,
                "prefix-icon": "left",
                style: { 
          borderColor: '#0275ff',
          borderWidth: '1px',
          borderStyle: 'solid',
          color: '#0275ff',
          backgroundColor: 'white',
          transition: 'background-color 0.3s, color 0.3s',
        },
                onMouseover: _cache[0] || (_cache[0] = ($event: any) => {$event.target.style.backgroundColor = '#0275ff'; $event.target.style.color = 'white'}),
                onMouseout: _cache[1] || (_cache[1] = ($event: any) => {$event.target.style.backgroundColor = 'white'; $event.target.style.color = '#0275ff'})
              })
            ]),
            _createVNode(_component_FormKit, {
              type: "submit",
              label: "Ajouter des variants",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(router).push({ name: 'customAddAttribut', params: { uuid: _unref(route).params.uuid }}))),
              style: { 
          borderColor: '#0275ff',
          borderWidth: '1px',
          borderStyle: 'solid',
          color: '#0275ff',
          backgroundColor: 'white',
          transition: 'background-color 0.3s, color 0.3s',
        },
              onMouseover: _cache[3] || (_cache[3] = ($event: any) => {$event.target.style.backgroundColor = '#0275ff'; $event.target.style.color = 'white'}),
              onMouseout: _cache[4] || (_cache[4] = ($event: any) => {$event.target.style.backgroundColor = 'white'; $event.target.style.color = '#0275ff'})
            })
          ])
        ]),
        empty: _withCtx(() => [
          _createTextVNode("Ce produit n’a pas de variants.")
        ]),
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_unref(Column), {
              field: "properties.adminProductName.value",
              header: "Nom du variant"
            }, {
              body: _withCtx((slotProps) => [
                _createTextVNode(_toDisplayString(slotProps.data.properties.adminProductName[0].value), 1)
              ]),
              _: 1
            }),
            _createVNode(_unref(Column), { header: "Attribut (valeur)" }, {
              body: _withCtx((slotProps) => [
                _createTextVNode(_toDisplayString(stringifyProductComponentObject(slotProps.data.attributes)), 1)
              ]),
              _: 1
            }),
            _createVNode(_unref(Column), {
              field: "properties.brand.value",
              header: "Marque"
            }, {
              body: _withCtx((slotProps) => [
                _createTextVNode(_toDisplayString(slotProps.data.properties.brand[0].value), 1)
              ]),
              _: 1
            }),
            _createVNode(_unref(Column), {
              field: "supplier.value",
              header: "Fournisseur"
            }),
            _createVNode(_unref(Column), { header: "Statut" }, {
              body: _withCtx((slotProps) => [
                _createElementVNode("span", null, _toDisplayString(_unref(formatStatus)(
                    slotProps.data.status.active,
                    slotProps.data.status.hiddenProduct,
                    slotProps.data.status.closedSale
                  )), 1)
              ]),
              _: 1
            }),
            _createVNode(_unref(Column), { headerStyle: "width: 12em;" }, {
              header: _withCtx(() => [
                _hoisted_4
              ]),
              body: _withCtx((slotProps) => [
                _createVNode(_component_router_link, {
                  to: { name: 'EditVariantProduct', params: { uuid: slotProps.data.uuid }}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(Button), {
                      size: "small",
                      icon: "pi pi-pencil",
                      class: "p-button-warning",
                      style: {"margin-right":"0.5em"},
                      title: "Éditer"
                    })
                  ]),
                  _: 2
                }, 1032, ["to"]),
                _createVNode(_unref(Button), {
                  size: "small",
                  icon: "pi pi-trash",
                  class: "p-button-danger",
                  style: {"margin-right":"0.5em"},
                  title: "Archiver",
                  disabled: slotProps.data.isDefault,
                  onClick: ($event: any) => (onDelete(slotProps.data.uuid))
                }, null, 8, ["disabled", "onClick"])
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      }, 8, ["value", "rows", "loading", "globalFilterFields"])
    ]),
    _: 1
  }))
}
}

})